import {
  faTrashCan,
  faClockRotateLeft,
} from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";

export type PaymentTermTab = "active" | "archived";

export interface BatchActionHandlers {
  onDelete: () => void;
  onRestore: () => void;
}

export const buildPaymentTermBatchActions = (
  tab: PaymentTermTab,
  _selectedCount: number,
  handlers: BatchActionHandlers
): BatchAction[] => {
  if (tab === "archived") {
    return [
      {
        icon: faClockRotateLeft,
        label: "Restore",
        onClick: handlers.onRestore,
      },
    ];
  }
  return [
    {
      icon: faTrashCan,
      label: "Delete",
      onClick: handlers.onDelete,
      variant: "danger",
    },
  ];
};
